import { Box, Drawer, Typography } from '@mui/material';
import { FunctionComponent } from 'react';

import { BedroomsQuery } from '../../../../../apollo/__generated__/graphql';
import { BedroomForm } from '../BedroomForm/BedroomForm';
import { useCreateBedroomDrawer } from './useCreateBedroomDrawer';

interface CreateBedroomDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  placeId: string | null;
  otherBedrooms: BedroomsQuery['bedrooms'];
}

export const CreateBedroomDrawer: FunctionComponent<
  CreateBedroomDrawerProps
> = ({ isOpen, onClose, placeId, otherBedrooms }) => {
  const { errors, onSubmit, register } = useCreateBedroomDrawer(
    placeId,
    onClose,
    otherBedrooms,
  );

  return (
    <Drawer anchor="right" open={isOpen} onClose={onClose}>
      <Box sx={{ mt: 10, mx: 2 }}>
        <Typography variant="h4">Créer une chambre</Typography>
        <BedroomForm
          errors={errors}
          register={register}
          onSubmit={onSubmit}
          submitButtonLabel="Créer"
        />
      </Box>
    </Drawer>
  );
};
